import ApiService from './ApiService';

export default class CustomServiceService {
  static create(data, recaptchaToken) {
    return ApiService.post('/custom-services', data, { headers: { Recaptcha: recaptchaToken } });
  }

  static createSpecification(id, data) {
    return ApiService.post(`/custom-services/${id}/spec`, data);
  }

  static createAttachment(id, data) {
    return ApiService.post(`/custom-services/${id}/attachment`, data);
  }

  static purchase(id, data) {
    return ApiService.post(`/custom-services/${id}/purchase`, data);
  }

  static requestCustomService(data) {
    return ApiService.post('/custom-services/send-email-request', data);
  }
}
